module.exports = __webpack_public_path__ + "img/BourgeoisRounded-BoldCondensed.7e0e1b5f.svg";